export default __webpack_public_path__ + "static/intel-d91a252b326b3eead336cbee9878ba2f.png";